export const useMusic = () => {
  const loadNewOrderMP3 = async () => {
    const module = await import('@@/shared-components/sounds/newOrder.mp3')
    return module.default
  }

  const loadBeepMP3 = async () => {
    const module = await import('@@/shared-components/sounds/beep.mp3')
    return module.default
  }

  const play = (audioSrc: string) => {
    const audio = new Audio(audioSrc)
    audio.play()
  }

  const playMusic = async (type?: string) => {
    if (navigator.userActivation.hasBeenActive) {
      switch (type) {
        case 'order':
          return await loadNewOrderMP3().then(play)
        case 'beep':
          return await loadBeepMP3().then(play)
        default:
          return await loadNewOrderMP3().then(play)
      }
    } else {
      console.warn('The user did not make any interaction')
    }
  }

  return { playMusic }
}
